import { useQuery } from "@tanstack/vue-query";

import consentTemplateService from "@/services/modules/consentTemplate";

import type { GetConsentTemplatesParams } from "@/services/modules/consentTemplate";
import type { Ref } from "vue";

export const CONSENTS_QUERY_KEYS = {
  ROOT: "consents",
  INDEX: "consents-index",
} as const;

export const useConsentsIndexQuery = (
  searchParams?: Ref<GetConsentTemplatesParams>
) => {
  return useQuery({
    queryKey: [
      CONSENTS_QUERY_KEYS.ROOT,
      CONSENTS_QUERY_KEYS.INDEX,
      searchParams,
    ],
    queryFn: async () => {
      return await consentTemplateService.getAllTemplates({
        ...searchParams?.value,
      });
    },
    staleTime: Infinity,
  });
};
